/* * @Author: knight * @Title: 视频下方导航组件 * @Date: 2020-04-08 15:29:38 *
@Last Modified by: knight * @Last Modified time: 2020-04-26 16:57:58 */
<template>
  <div class="nav-wrapper" id="cheese_nav">
    <div class="nav">
      <ul
        class="list"
        ref="list"
        :style="{ visibility: checked ? 'visible' : 'hidden' }"
      >
        <li
          class="item ell"
          v-for="(item, index) in realList"
          :key="index"
          @click="handleChecked(item.id, index, item.name)"
        >
          <p>{{ item.name }}</p>
        </li>
        <li class="item ell" @click="handleMore()" v-if="showMore">
          <p>更多</p>
        </li>
      </ul>

      <div class="nav-right" ref="rightnav">
        <div class="nav-right-item" v-if="recommend_activity.title">
          <a :href="recommend_activity.link" target="_blank" class="recom" @click="adReport()"></a>
          <a
            :href="recommend_activity.link"
            title="配置的活动链接"
            target="_blank"
            class="rec-title ell"
            v-href
            >{{ recommend_activity.title }}</a
          >
        </div>
        <div class="nav-right-item">
          <span @click="handleIsLogin" class="mine"></span>
          <span class="myClassroom" @click="handleIsLogin">我的课程中心</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { quickLogin } from 'g-public/utils'
import { openWindowWithCsource } from '@src/public/js/convert'
import { report } from "../../public/report/index";

export default {
  components: {},
  props: {
    lists: {
      required: true,
      type: Array,
      default: () => [],
    },
    recommend_activity: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      realList: [],
      showMore: false,
      checked: false,
    }
  },
  created() {},
  mounted() {
    // this.calculateRealList();
  },
  watch: {
    lists(val) {
      if (val && val.length > 0) {
        this.$nextTick(() => {
          this.calculateRealList()
        })
      }
    },
  },
  computed: {
    ...mapState(['loginInfo']),
    isLogin() {
      if (this.loginInfo && this.loginInfo.isLogin) return true
      return false
    },
  },
  methods: {
    handleIsLogin() {
      report('my_lecture')
      if (!this.isLogin) {
        return quickLogin()
      } else {
        openWindowWithCsource('https://www.bilibili.com/v/cheese/mine/list')
      }
    },

    handleChecked(id, index, name) {
      report('select_channel', {name})
      openWindowWithCsource(`https://www.bilibili.com/cheese/category?first=${id}`)
    },
    handleMore() {
      openWindowWithCsource('https://www.bilibili.com/cheese/category')
    },
    calculateRealList() {
      let idx = 1
      const that = this
      function iterateList() {
        that.realList = that.lists.slice(0, idx)
        that.$nextTick(() => {
          const rect1 = that.$refs.list.getBoundingClientRect()
          const rect2 = that.$refs.rightnav.getBoundingClientRect()
          if (rect2.left - rect1.right < 180) {
            that.checked = true
            that.realList = that.lists.slice(0, idx - 1)
            that.showMore = true
          } else {
            if (idx >= that.lists.length) {
              that.checked = true
            } else {
              idx++
              iterateList()
            }
          }
        })
      }
      iterateList()
    },
    adReport() {
      report('adv_fixed')
    }
  },
}
</script>

<style lang="less" scoped>
.nav-wrapper {
  width: 100%;
  height: 80px;
  line-height: 80px;
  color: #212121;
  background-color: rgba(33, 33, 33, 0.05);
}

.nav {
  width: 1286px;
  margin: 0 auto;

  display: flex;
  justify-content: space-between;
}

.myClassroom {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  &:hover {
    color: #0ba395;
  }
}

.icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

.icon-user {
  background: url();
}

.rec-title {
  display: inline-block;
  vertical-align: middle;
  color: #212121;
  width: 100px;
  font-size: 12px;
  &:hover {
    color: #0ba395;
  }
}

.list {
  display: flex;
}

.item {
  margin-right: 30px;
  cursor: pointer;
  &:hover {
    color: #0ba395;
  }
}
.nav-right {
  white-space: nowrap;
  min-width: 265px;
}

.nav-right-item {
  display: inline-block;
  line-height: normal;
  padding-top: 12px;
  &:first-child {
    margin-right: 30px;
  }
  &:last-child {
    margin-right: 0;
  }
  .recom {
    width: 28px;
    height: 28px;
    background: url("../assets/images/recom.svg");
    margin: 0 auto;
    margin-bottom: 8px;
    display: block;
  }
  .mine {
    width: 28px;
    height: 28px;
    background: url("../assets/images/mine.svg");
    margin: 0 auto;
    margin-bottom: 8px;
    display: block;
    cursor: pointer;
  }
}

@media screen and (max-width: 1438px) {
  .nav {
    width: 1070px;
  }
}
</style>
